import { GoogleLoginRequest, TokenResponse } from "@bluefalcon/users-management-client-fetch";
import { falconClients } from "../clients/falcon.client";
import { getToken } from "@bluefalcon/utils-package";

export type LoginRequest = {
    username: string;
    password: string;
    tenantId?: string;
};

export class AuthService {

    async login(request: LoginRequest): Promise<TokenResponse> {
        try {
            return falconClients.auth.grantAccessToken({
                grantAccessTokenRequest: request,
            });
        } catch (e: any) {
            console.error({ error: e }, "Failed to login");
            throw e;
        }
    }

    async refresh(): Promise<TokenResponse> {
        return falconClients.auth.refreshToken({
            refresh: getToken("bf_refresh") ?? "",
        });
    }

    async logout(): Promise<void> {
        return falconClients.auth.logout({
            sessionId: Number(getToken('bf_session_id') ?? 0),
        });
    }

    async sendResetPasswordEmail(userId: string): Promise<void> {
        return falconClients.admin.sendResetPasswordEmailAdmin({
            userId,
        });
    }

    async googleLogin(data: GoogleLoginRequest): Promise<TokenResponse> {
        return falconClients.auth.googleLogin({ googleLoginRequest: data });
    }
}
